import React from 'react'

import FormField from '@cloudscape-design/components/form-field'
import Input  from '@cloudscape-design/components/input'
import { ReactNode } from 'react'
import { NonCancelableEventHandler } from '@cloudscape-design/components/internal/events'
import { BaseChangeDetail } from '@cloudscape-design/components/input/interfaces'

export type LabeledInputProps = {
    label: string,
    value: string, 
    onChange?: NonCancelableEventHandler<BaseChangeDetail>, 
    validate?: (value: string, label: string) => boolean,
    readOnly?: boolean, 
    [rest: string]: any,
}

export default ({ label, value, onChange, validate, readOnly = false, ...rest }: LabeledInputProps): ReactNode => {

    // if (readOnly) {
    //     return (
    //         <div>
    //             {label + ': '}
    //             <b style={{width: '100px'}}>{value}</b>
    //         </div> 
    //     ) 
    // }

    const valid = (!readOnly && validate) ? validate(value, label) : true

    return (
        <FormField label={label} info={label ? validate || readOnly ? '' : 'Optional' : ''} >
            <Input readOnly={readOnly}
                value={value}
                onChange={onChange}
                invalid={!readOnly && !valid}
                {...rest}
            />
        </FormField> 
    )
}